<template>
  <div class="loginlink">
    <a :href="link">Mit Google anmelden</a>
  </div>
</template>
<script>
export default {
  data() {
    return {
      link: '',
    }
  },
  mounted() {
    console.log("mounted login");
    fetch('/sh/auth/url')
    .then(res => res.json())
    .then(res => this.link = res.url);
  }
}
</script>
<style scoped>
div.loginlink {
  text-align: center;
  width: 400px;
  height: 100px;
  margin: 40px auto;
}
</style>